import { fetchMe } from '../api/auth';
import { PlatformAuthBootstrap } from '@jarvis/platform-ui';
import { useAuthStore } from './useAuthStore';

/** Loads `/api/auth/me` once — Entra cookie session via WebOpsApi BFF. */
export function AuthBootstrap() {
  return (
    <PlatformAuthBootstrap
      fetchMe={fetchMe}
      isAuthenticated={(me) => me.authenticated}
      mapAuthenticated={(me) => ({
        username: me.username,
        displayName: me.displayName,
        roles: me.roles ?? []
      })}
      useAuthStore={useAuthStore}
    />
  );
}
